var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, useEffect, useCallback } from "react";
import * as pc from "playcanvas";
import { Node3D } from "./node-3d";
import { NodeUI } from "./node-ui";
import { useAppSelector, selectors } from "store";
import { OverlayData } from "store/types";
import { useNodeWarnings } from "hooks/node-warnings";
export var Node = function (_a) {
    var _b;
    var app = _a.app, modelAssets = _a.modelAssets, materialAssets = _a.materialAssets, node = _a.node, movingNodeIds = _a.movingNodeIds, hoverId = _a.hoverId, hoveredNodeTooltipId = _a.hoveredNodeTooltipId, onTooltipHover = _a.onTooltipHover;
    var _c = __read(useState(null), 2), nodeEntity = _c[0], setNodeEntity = _c[1];
    var _d = __read(useState(null), 2), boundingBox = _d[0], setBoundingBox = _d[1];
    var _e = __read(useState(null), 2), position = _e[0], setPosition = _e[1];
    var overlayData = useAppSelector(selectors.selectOverlayData);
    var warnings = useNodeWarnings(node);
    var isZoomedIn = useAppSelector(selectors.selectIsZoomedIn(node.id));
    var selectedIds = useAppSelector(selectors.selectSelectedIds);
    var isMultiSelecting = useAppSelector(selectors.selectIsMultiSelecting);
    var isPerformanceOverlay = overlayData === OverlayData.PERFORMANCE_DATA;
    var isSelected = selectedIds.includes(node.id) && !isPerformanceOverlay;
    var isHovered = hoverId === node.id;
    var isMoving = (_b = movingNodeIds === null || movingNodeIds === void 0 ? void 0 : movingNodeIds.includes(node.id)) !== null && _b !== void 0 ? _b : false;
    var isNoneSelected = selectedIds.length === 0;
    var hasWarnings = warnings.length > 0;
    useEffect(function () {
        var entity = new pc.Entity(node.id.toString());
        app.root.addChild(entity);
        setNodeEntity(entity);
        return function () {
            entity.destroy();
            setNodeEntity(null);
        };
    }, [app.root, node.id]);
    var onPositionChange = useCallback(function (pos) {
        setPosition(pos);
    }, []);
    var onBoundingBoxChange = useCallback(function (bbox) {
        setBoundingBox(bbox);
    }, []);
    if (!nodeEntity)
        return null;
    return (_jsxs(_Fragment, { children: [_jsx(Node3D, { app: app, node: node, nodeEntity: nodeEntity, materialAssets: materialAssets, hoverId: hoverId, position: position, onPositionChange: onPositionChange, onBoundingBoxChange: onBoundingBoxChange, isSelected: isSelected, isHovered: isHovered, hasWarnings: hasWarnings, overlayData: overlayData, isMultiSelecting: isMultiSelecting, isZoomedIn: isZoomedIn }), _jsx(NodeUI, { app: app, node: node, nodeEntity: nodeEntity, modelAssets: modelAssets, materialAssets: materialAssets, position: position, boundingBox: boundingBox, isSelected: isSelected, isMoving: isMoving, isZoomedIn: isZoomedIn, isNoneSelected: isNoneSelected, isMultiSelecting: isMultiSelecting, hasWarnings: hasWarnings, hoverId: hoverId, hoveredNodeTooltipId: hoveredNodeTooltipId, onTooltipHover: onTooltipHover })] }));
};
